import { useMutation, useQueryClient } from '@tanstack/react-query';
import { createUser } from '../api/USERS/users';
import { toast } from 'react-toastify';

export const useCreateUser = () => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: createUser,
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['users'] });
            toast.success('Utilisateur créé avec succès');
        },
        onError: (error) => {
            toast.error(error.message || 'Erreur lors de la création de l\'utilisateur');
        },
    });
};
